module.exports = __webpack_public_path__ + "img/2.e254e3d0.jpg";